import { getThemeImageUrl } from '../../services/utils'
import l10n from '../i18n/I18N'

import classes from './infoSection.module.scss'

export const InfoSection = ({ children }) => {
  return (
    <div className={classes.infoSection}>
      <img
        src={getThemeImageUrl(classes.infoSectionErrorIcon)}
        alt={l10n.t['icons.tooltipErrorAlt']}
        className={classes.infoSection__errorIcon}
      />
      <div className={classes.infoSection__descriptionContent}>{children}</div>
    </div>
  )
}
